import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {AdminGuard} from '../admin.guard';
import {IndexComponent} from '../index/index.component';
import {LoginComponent} from '../login/login.component';
import {FrontpicturesComponent} from '../frontpictures/frontpictures.component';
import {FromssComponent} from '../fromss/admin.component';
import {AdminComponent} from '../admin/admin.component';
import {DummyComponent} from '../dummy/dummy.component';
import {IndexresolveService} from '../indexresolve.service';
import {ListfacultiesComponent} from '../listfaculties/listfaculties.component';
import { ListfacultiesService } from "../listfaculties.service";
import{WordsontopComponent} from '../wordsontop/wordsontop.component';
import {AddfacultiesComponent  } from "../addfaculties/addfaculties.component";
import {EditfacultyService} from "../editfaculty.service";
import {  EditfacultyComponent} from "../editfaculty/editfaculty.component";
import {AddemployeesComponent} from '../addemployees/addemployees.component';
import {EmployeeService} from '../employee.service';
import {ListemployeesComponent} from '../listemployees/listemployees.component';
import {EditemployeesComponent} from '../editemployees/editemployees.component';
import {AddwrittencontactComponent} from '../addwrittencontact/addwrittencontact.component';
import {AddnewsComponent } from "../addnews/addnews.component";

const appRoutes =[
 {path: 'index', component: IndexComponent, resolve:{omolayoresolver: IndexresolveService}},
{
  path: 'admin',  component: AdminComponent,   canActivate:[AdminGuard], canActivateChild: [AdminGuard],
children:[
  {  path: '', children:[
  {path: 'uploadfrontpictures', component: FromssComponent },
  {path: '', redirectTo:'/uploadfrontpictures', pathMatch: 'full'},
  {path: 'dummy', component: DummyComponent},
  {path: 'wordsontop', component: WordsontopComponent},
  {path: 'listfaculties', component:ListfacultiesComponent, resolve:{listfaculties: ListfacultiesService}},
  {path:  'addfaculties', component:AddfacultiesComponent},
  {path:'editfaculty/:name', component: EditfacultyComponent, resolve:{editfaculty:EditfacultyService}},
  {path:'addemployees', component: AddemployeesComponent},
  {path:'list/:listoredit/:what', component: ListemployeesComponent, resolve:{employees:EmployeeService}},
  {path:'edit/:listoredit/:what/:name', component: EditemployeesComponent, resolve:{employees:EmployeeService}},
  {path:'addwrittencontact/:where', component: AddwrittencontactComponent},
  {path:'addnews', component: AddnewsComponent},




]}]
},{
path: 'login', component: LoginComponent
},
{
path: '', redirectTo:'/index', pathMatch: 'full'
}]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes)
  ],

  exports:[ RouterModule]
})
export class RoutingModuleModule { }
